import { filter } from 'rxjs/operators';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ApplicationDetailsModel } from 'src/app/models/farmers-application.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { OnFarmMiService } from 'src/app/services/on-farm-mi.service';
import { DomSanitizer } from '@angular/platform-browser';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
import { ChallanService } from 'src/app/services/challan-services.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { Location } from '@angular/common'


@Component({
  selector: 'app-vendor-consent-form',
  templateUrl: './vendor-consent-form.component.html',
  styleUrls: ['./vendor-consent-form.component.scss'],
})
export class VendorConsentFormComponent implements OnInit {

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];

  userId: any;
  autoId: any;
  appDetails: any;
  public sanctionLetterData: any;
  public appId: any;
  public progID: any;
  public sanctionLetterDataForTable: any[];
  miDetails: any;
  PondVerData: any;
  PondVerDataStage2: any;
  PondVerDataStage3: any;
  calculatedSubsidyDataForMIPhys: any;
  preEstimateDetails: any;
  physicalSurveyDetails: any;

  optionsPreEstimate: any;
  overlaysPreEstimate: any[];
  showMapPreEstimate: any;

  optionsJE: any;
  overlaysJE: any[];
  showMapJE: any;

  optionsXEN: any;
  overlaysXEN: any[];
  showMapXEN: any;

  optionsSDO: any;
  overlaysSDO: any[];
  showMapSDO: any;

  miSurveyMapoptions: any;
  miSurveyoverlays: any[];
  miSurveyXENMapoptions: any;
  miSurveyXENoverlays: any[];

  applicationDetails: ApplicationDetailsModel = new ApplicationDetailsModel();
  applicationStatus: any;
  vendorApplicationDetails: any;
  // farmerDetails: any;
  farmerPreviousSubsidies: any = [];
  farmerId: any;
  farmerData2: any;
  displayFileDialog: boolean;
  state: string = 'default';
  rotatableFilePath: any;
  public totalArea = 0;
  displayCustom: boolean;
  displayCustom1: boolean;
  activeIndex: number = 0;
  items: any[];
  selectedStatus: any;
  remarks: String;
  //appId: String;
  vendorId: any;
  programId: any;
  isActionSectionEnabled: boolean;

  public isProDataCalculated: boolean = false;
  public proCalculatedData: any;
  public statusCode: any;
  public isPrintClicked: boolean = false;
  public userID: any;
  public cropType: any;
  public selectedCropType: any;
  public selectedCrop: any;

  public totalLandArea: number = 0;

  public existingMIDetails: any;

  //for multiple datasets
  public preEstimationDataArray: any = [];
  public miEstimationDataArray: any = [];
  public miBOQDataArray: any = [];
  public physicalSurveyDataArray: any = [];
  public sanctionLetterDataArray: any = [];
  public physicalSurveyDetailsArray: any = [];
  public imgVal: any;

  public surveyStage1JE: any = null;
  public surveyStage1XEN: any = null;
  public surveyStage2JE: any = null;
  public surveyStage2XEN: any = null;
  public calStage1JE: any = null;
  public calStage1DD: any = null;
  public calStage1DA: any = null;
  public calStage1DMICADA: any = null;
  public calStage1Admin: any = null;
  public calStage2JE: any = null;
  public calStage2DA: any = null;
  public calStage2DD: any = null;
  public calStage2DMICADA: any = null;
  public calStage2Admin: any = null;
  public tankStage3Data: any = null;
  public remarksData: any = null;
  public t3Attachments: any = null;
  public t3VendorDetails: any = null;
  public t3AttachmentsPondStage1: any = null;
  public t3AttachmentsPondStage2: any = null;
  public pondStage3Visibility: any = null;

  public pondS1Exist: boolean = false;
  public pondS2Exist: boolean = false;


  public FSTVDetails: any;
  public STVDetails: any;
  public STFDetails: any;
  public RTFDetails: any;
  public PondStage1: any;
  public PondStage2: any;
  public PondStage3: any;

  public showSubsidyDetails: boolean = false;
  public showFarmerShareDepositeDetails: boolean = false;
  public farmerShareDepositeDetails: any;
  public viewLinkMasked: any;

  public userRole: any;

  constructor(
    private route: ActivatedRoute,
    private _dashboardService: DashboardService,
    private ofService: OnFarmMiService,
    private messageService: MessageService,
    private farmerAppSer: FarmersApplicationService,
    private sanitizer: DomSanitizer,
    private deptDashBoardService: DepartmentDashboardService,
    private vendorService: VendorDashboardService,
    private router: Router,
    private cryptoJsService: CryptoJsService,
    private challanMIService: ChallanService,
    private jeService: JEService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private location: Location
  ) { }

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]); 
    this.userRole = JSON.parse(payload)?.sub;

    this.getCropMaster();

    // this.appId = this.cryptoJsService.DecryptData(this.route.snapshot.paramMap.get('appId'));
    this.route.queryParams.subscribe(params => {
      const encryptedMobile = params['appId'];
      if (encryptedMobile) {
        this.appId = this.cryptoJsService.DecryptData(encryptedMobile);
      } else {
        // setTimeout(()=> this.onClickBack(), 1300);
      }
    });

    if (!this.appId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data Error : Cannot Load Form Due to Missing Application Id.',
      });
      return;
    }
    // this.vendorId = this.route.snapshot.paramMap.get('vendorId');
    // this.programId = this.route.snapshot.paramMap.get('programId');
    // this.autoId = this.route.snapshot.paramMap.get('autoId');
    // this.userId = this.route.snapshot.paramMap.get('userId');

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let farmerData = farmerConfData.get('farmerDetails');

    this.farmerData2 = farmerData;

    this.farmerId = farmerConfData.get('Farmer_Id_');
    // this.farmerMobileNo = farmerConfData.get('farmerPh');

    if (this.appId) {
      this.getApplicationDetails(this.appId);
      this.getExistingMIDetails(this.appId);
      this.getApplicationStatus(this.appId);
      // this.getPondVerDataSatge1(this.appId);
      // this.getPondVerDataSatge2(this.appId);
      this.getPondVerDataSatge3(this.appId);
      this.getGetSubsidyDetails(this.appId);
      this.challanPaymentDetails(this.appId);
    }
  }

  onClickBack() {
    this.location.back();
  }

  getCropMaster() {
    // this.loader.start();
    this.vendorService
      .getCropMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.cropType = res;
          // this.loader.close();
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Crop Master not loaded.',
          });
        },
      });
  }

  // getPastSubsidiesByFarmerId(farmerID) {
  //   // if (this.farmerId) {
  //   this.loader.start();
  //   this.ofService
  //     .GetFarmerPastSubsidyByFarmerId(farmerID)
  //     .pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         this.farmerPreviousSubsidies = data;
  //         this.loader.close();
  //       },
  //       error: () => {
  //         this.loader.close();
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: 'Data error! Farmer Previous Subsidies not loaded.',
  //         });
  //       },
  //     });
  //   // }
  // }

  // getPastSubsidiesByMultipleFarmerIds(GroupTableData) {
  //   let farmerIds = [];
  //   GroupTableData.forEach((farmer) => {
  //     farmerIds.push(farmer.FarmerID.toString());
  //   });
  //   if (farmerIds.length) {
  //     this.loader.start();
  //     this.ofService
  //       .GetFarmerPastSubsidyByMultipleFarmerIds(farmerIds)
  //       .pipe(first())
  //       .subscribe({
  //         next: (data) => {
  //           this.farmerPreviousSubsidies = data;
  //           this.loader.close();
  //         },
  //         error: () => {
  //           this.loader.close();
  //           this.messageService.add({
  //             severity: 'error',
  //             summary: 'Error Message',
  //             detail: 'Data error! Farmer Previous Subsidies not loaded.',
  //           });
  //         },
  //       });
  //   } else {
  //     this.messageService.add({
  //       severity: 'error',
  //       summary: 'Error Message',
  //       detail: 'Data error! Group-Farmers Previous Subsidies not Fetched.',
  //     });
  //     return;
  //   }
  // }

  getApplicationDetails(appId) {
    this.loader.start();
    this._dashboardService.getApplicationByAppId(appId).subscribe((res) => {
      this.loader.close();
      if (res) {
        this.applicationDetails = res;

        // res.ListViewFormData = [
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   },
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   }
        // ]

        if (res.ListViewFormData && res.ListViewFormData.length > 0) {
          res.ListViewFormData.forEach((val) => {
            let autoId = val?.AutoId;
            let progId = val?.ProgId
            let userId = val?.User_ID;
            let vendorId = val?.VendorId;

            if (autoId != null && userId != null) {
              this.getCalculatedSubsidyDataForMIPhys(autoId, userId);
            }

            if (autoId != null && progId != null) {
              this.getPreEstimationData(this.appId, progId);
            }

            if (this.appId != null && progId != null) {
              this.getSanctionLetterData(this.appId, progId);
            }

            if (vendorId != null && progId != null) {
              this.getMIEstimationData(this.appId, vendorId, progId);
              this.getMIBOQData(this.appId, vendorId, progId);
            }

            if (autoId != null && userId != null) {
              this.getPhysicalSurveyData(autoId, userId);
            }
          });
        }

        if (
          this.applicationDetails.FarmerLand &&
          this.applicationDetails.FarmerLand.length > 0
        ) {
          this.applicationDetails.FarmerLand.forEach(
            (val) => (this.totalLandArea += parseFloat(val.totalArea))
          );
        }

        this.totalArea = 0;
        if (this.applicationDetails?.New_MI_Datas && this.applicationDetails?.New_MI_Datas.length > 0) {
          this.applicationDetails.New_MI_Datas = this.applicationDetails.New_MI_Datas.filter((val) => {
            return (!(val?.miVendorName == null || val?.miVendorName == '') && !(val?.VendorCode == null && val?.VendorCode == 0))
          });
          this.applicationDetails.New_MI_Datas.forEach(
            (val) => (this.totalArea += parseFloat(val.totalArea))
          );
        }

        let farmerId = res.Farmer_ID;
        // if (res?.GroupTableData) {
        //   this.getPastSubsidiesByMultipleFarmerIds(res?.GroupTableData);
        // } else {
        //   this.getPastSubsidiesByFarmerId(farmerId);
        // }
        if(this.applicationDetails?.FarmerPersonalData?.Aadhar_No){
          if(this.userRole && (this.userRole ==='DMICADA' || this.userRole ==='DD Associate' || this.userRole ==='CAO' || this.userRole == 'DD-EW' || this.userRole == 'JE-EW' || this.userRole == 'DDMI' || this.userRole == 'DDTank')){
              this.viewLinkMasked = false;
          }
          else{
            this.viewLinkMasked = true;
            this.applicationDetails.FarmerPersonalData.Aadhar_No=this.maskNumber(this.applicationDetails?.FarmerPersonalData?.Aadhar_No)
            this.applicationDetails.FarmerPersonalData.PPP_ID=this.maskNumber(this.applicationDetails?.FarmerPersonalData?.PPP_ID)
          }
        }
      }
    },
      err => {
        this.loader.close();
      });
  }

  getApplicationStatus(appId) {
    // this.loader.start();
    this._dashboardService
      .getApplicationStatusByAppId(appId)
      .subscribe((res) => {
        // this.loader.close();
        if (res) {
          this.applicationStatus = res.replace('Application Status: ', '');
        }
      });
  }

  getPondVerDataSatge1(appId) {
    this.jeService
      .getPondVerDataByAppIdStage1(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.PondVerData = data;
          // sessionStorage.setItem('pondData', JSON.stringify(data));
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  getPondVerDataSatge2(appId) {
    this.jeService
      .getPondVerDataByAppIdStage2(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.PondStage2Status == 1) {
            this.PondVerDataStage2 = data;
          }
          // sessionStorage.setItem('pondData', JSON.stringify(data));
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  getPondVerDataSatge3(appId) {
    this.jeService
      .getPondVerDataByAppId_SubsidyCalc_Stage3(appId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          if (res) {
            this.PondVerDataStage3 = res;
            this.surveyStage1JE = res[1][0];
            if (this.surveyStage1JE?.IsExist == 1) {
              this.pondS1Exist = true;
            } else {
              this.pondS1Exist = false;
            }
            this.surveyStage1XEN = res[0][0];
            this.surveyStage2JE = res[3][0];
            if (this.surveyStage2JE?.IsExist == 1) {
              this.pondS2Exist = true;
            } else {
              this.pondS2Exist = false;
            }
            this.surveyStage2XEN = res[2][0];
            this.calStage1JE = res[5][0];
            this.calStage1DD = res[6][0];
            this.calStage1DA = res[7][0];
            this.calStage1DMICADA = res[8][0];
            this.calStage1Admin = res[4][0];
            this.calStage2JE = res[10][0];
            this.calStage2DD = res[11][0];
            this.calStage2DA = res[12][0];
            this.calStage2DMICADA = res[13][0];
            this.calStage2Admin = res[9][0];
            this.tankStage3Data = res[14][0];
            this.remarksData = res[15][0];
            this.t3Attachments = res[16];
            this.t3VendorDetails = res[17][0];
            this.t3AttachmentsPondStage1 = res[18];
            this.t3AttachmentsPondStage2 = res[19];
            // this.pondStage3Visibility = res[18][0];
          } else {
            this.surveyStage1JE = null;
            this.surveyStage1XEN = null
            this.surveyStage2JE = null;
            this.surveyStage2XEN = null;
            this.calStage1JE = null;
            this.calStage1DD = null;
            this.calStage1DA = null;
            this.calStage1DMICADA = null;
            this.calStage1Admin = null
            this.calStage2JE = null;
            this.calStage2DD = null;
            this.calStage2DA = null;
            this.calStage2DMICADA = null;
            this.calStage2Admin = null;
            this.tankStage3Data = null;
            this.remarksData = null; null
          }
          // sessionStorage.setItem('pondData', JSON.stringify(data));
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  getGetSubsidyDetails(appId) {
    this.jeService
      .getSubsidyDetails(appId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          if (res) {
            this.STFDetails = res[0][0];
            this.STVDetails = res[1][0];
            this.RTFDetails = res[2][0];
            this.FSTVDetails = res[3][0];
            this.PondStage1 = res[4][0];
            this.PondStage2 = res[5][0];
            this.PondStage3 = res[6][0];
            if (this.STFDetails?.IsExist == 1 || this.STVDetails?.IsExist == 1 || this.RTFDetails?.IsExist == 1 || this.FSTVDetails?.IsExist == 1
              || this.PondStage1?.IsExist == 1 || this.PondStage2?.IsExist == 1 || this.PondStage3?.IsExist == 1) {
              this.showSubsidyDetails = true;
            } else {
              this.showSubsidyDetails = false;
            }
          } else {
            this.FSTVDetails = null;
            this.STVDetails = null;
            this.STFDetails = null;
            this.RTFDetails = null;
            this.PondStage1 = null;
            this.PondStage2 = null;
            this.PondStage3 = null;
          }
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  onPrint(divName) {
    // var printContents = document.getElementById(divName).innerHTML;
    // var originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
    document.body.style.visibility = 'hidden';
    document.getElementById(divName).style.visibility = 'visible';
    window.print();
    document.body.style.visibility = 'visible';
  }

  public viewWorkFlowAllStatus: boolean = false;
  workFlowAllStatus() {
    this.viewWorkFlowAllStatus = true;
    // <app-workFlowAllStatus></app-workFlowAllStatus>
    // this.router.navigate([
    //   `dashboard/${this.route.snapshot.paramMap.get(
    //     'appId'
    //   )}`,
    // ]);
  }

  openFileDialog(filePath) {
    this.rotatableFilePath = filePath;
    this.displayFileDialog = true;
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      this.rotatableFilePath
    );
  }

  onCloseDialog() {
    this.displayFileDialog = false;
  }

  @ViewChild('myname') myname: ElementRef;
  rotationAmount = 0;
  scalingAmount = 1;
  transformImage(direction, scale) {
    if (direction) {
      this.rotationAmount += direction == 'left' ? -90 : 90;
    }
    if (scale) {
      this.scalingAmount += scale == 'zoom-out' ? -0.1 : 0.1;
    }
    this.myname.nativeElement.style.transform = `rotate(${this.rotationAmount}deg) scale(${this.scalingAmount})`;
  }

  numberEquals(num1, num2) {
    return Number(num1) == Number(num2);
  }

  // onPrintSanctionLetter(divName) {
  //   this.isPrintClicked = true;
  //   var printContents = document.getElementById(divName).innerHTML;
  //   var originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // }

  imageClick(index: number, val) {
    this.activeIndex = index;
    this.displayCustom = true;
    this.imgVal = val;
  }

  imageClick1(index: number, val) {
    this.activeIndex = index;
    this.displayCustom1 = true;
    this.imgVal = val;
  }

  //pre-estimation
  getPreEstimationData(appId, programId) {
    if (appId && programId) {
      this.deptDashBoardService
        .getApplicationDataOfPreEstimation(appId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.preEstimateDetails = data;

            if (
              this.preEstimateDetails.CropTypeID &&
              this.preEstimateDetails.CropId
            ) {
              this.cropType.forEach((res) => {
                if (res.data === data.CropTypeID) {
                  // this.selectedCropType = res.label;
                  let crop = res.children;
                  crop.forEach((res2) => {
                    if (res2.data === data.CropId) {
                      this.preEstimateDetails = {
                        ...data,
                        selectedCropType: res?.label,
                        selectedCrop: res2.label,
                      };
                      // this.selectedCrop = res2.label;
                    }
                  });
                  return;
                }
              });
            }

            if (this.preEstimateDetails.listGPSCoordinates.length > 0) {
              this.showMapPreEstimate = true;
              let locationArray = [];
              this.preEstimateDetails.listGPSCoordinates.forEach((e) => {
                locationArray.push({ lat: e.Latitude, lng: e.Longitude });
              });
              this.optionsPreEstimate = {
                center: {
                  lat: locationArray[0].lat,
                  lng: locationArray[0].lng,
                },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
              };
              let pointLocations = [];
              locationArray.forEach((e) => {
                pointLocations.push(
                  new google.maps.Marker({
                    position: { lat: e.lat, lng: e.lng },
                  })
                );
              });
              this.overlaysPreEstimate = [
                ...pointLocations,
                new google.maps.Polygon({
                  paths: [...locationArray],
                  strokeOpacity: 0.5,
                  strokeWeight: 1,
                  fillColor: '#1976D2',
                  fillOpacity: 0.35,
                }),
              ];

              this.preEstimateDetails = {
                ...this.preEstimateDetails,
                overlaysPreEstimate: this.overlaysPreEstimate,
                optionsPreEstimate: this.optionsPreEstimate,
              };
            } else {
              this.showMapPreEstimate = false;
            }

            this.preEstimationDataArray.push(this.preEstimateDetails);
          },
          error: () => { },
        });
    }
  }

  getMIEstimationData(appId, vendorId, programId) {
    if (appId && vendorId && programId) {
      this.deptDashBoardService
        .getVendorMIEstimation(this.appId, vendorId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            if (data?.CropTypeID && data?.CropID) {
              this.cropType.forEach((res) => {
                if (res.data === data.CropTypeID) {
                  // this.selectedCropType = res.label;
                  let crop = res.children;
                  crop.forEach((res2) => {
                    if (res2.data === data.CropID) {
                      data = {
                        ...data,
                        selectedCropType: res?.label,
                        selectedCrop: res2.label,
                      };
                      // this.selectedCrop = res2.label;
                    }
                  });
                  return;
                }
              });
            }

            // if(data?.EstimationComponentDetail && data?.EstimationComponentDetail.length > 0){
            //   data?.EstimationComponentDetail.map(val => ({
            //     ...val,
            //     totalCost: val.Price*val.Quantity
            //   }))
            //   let componentTotal = 0;
            //   data?.EstimationComponentDetail.forEach(val => {
            //     componentTotal += val.Price*val.Quantity;
            //   })

            //   data = {
            //     ...data,
            //     componentTotal: componentTotal
            //   }
            // }

            if (data?.AppID) {
              this.miEstimationDataArray.push(data);
            }
          },
          error: () => {
            // this.loader.close();
            // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
          },
        });
    }
  }

  getExistingMIDetails(appId) {
    this._dashboardService.getExistingMIDetails(appId).subscribe((res) => {
      this.existingMIDetails = res;
    })
  }

  getSanctionLetterData(appId, progID) {
    this.challanMIService
      .getSanctionLetterData(appId, progID)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.sanctionLetterDataArray.push(res);
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  getMIBOQData(appId, vendorId, programId) {
    if (appId && vendorId && programId) {
      this.deptDashBoardService
        .getVendorMIBOQ(this.appId, vendorId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.appDetails = data;
            // this.vendorApplicationDetails = data;
            if (data?.BoqStatus == 1) {
              this.miBOQDataArray.push(data);
            }
          },
          error: () => {
            // this.loader.close();
            // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
          },
        });
    }
  }

  getPhysicalSurveyData(autoId, userId) {
    if (autoId && userId) {
      this.jeService
        .getApplicationDataForPhysicalVerification(autoId, userId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.calculatedSubsidyDataForMIPhys = data;
          },
          error: () => {
            // this.loader.close();
            // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
          },
          complete: () => {
            // this.loader.start();
            this.jeService
              .getApplicationDataForPhysicalVerification_CalculatedSubsidy(
                autoId,
                userId
              )
              .pipe(first())
              .subscribe({
                next: (data) => {
                  if (data['PhySurveyStatus'] == 1) {
                    this.physicalSurveyDetails = data;

                    if (
                      this.physicalSurveyDetails.listGPSCoordinatesJE.length > 0
                    ) {
                      this.showMapJE = true;
                      let locationArray = [];
                      this.physicalSurveyDetails.listGPSCoordinatesJE.forEach(
                        (e) => {
                          locationArray.push({
                            lat: e.Latitude,
                            lng: e.Longitude,
                          });
                        }
                      );
                      this.optionsJE = {
                        center: {
                          lat: locationArray[0].lat,
                          lng: locationArray[0].lng,
                        },
                        zoom: 17,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                      };
                      let pointLocations = [];
                      locationArray.forEach((e) => {
                        pointLocations.push(
                          new google.maps.Marker({
                            position: { lat: e.lat, lng: e.lng },
                          })
                        );
                      });
                      this.overlaysJE = [
                        ...pointLocations,
                        new google.maps.Polygon({
                          paths: [...locationArray],
                          strokeOpacity: 0.5,
                          strokeWeight: 1,
                          fillColor: '#1976D2',
                          fillOpacity: 0.35,
                        }),
                      ];

                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        optionsJE: this.optionsJE,
                        overlaysJE: this.overlaysJE,
                      };
                    } else {
                      this.showMapJE = false;
                    }

                    if (
                      this.physicalSurveyDetails.listGPSCoordinatesXEN.length >
                      0
                    ) {
                      this.showMapXEN = true;
                      let locationArray = [];
                      this.physicalSurveyDetails.listGPSCoordinatesXEN.forEach(
                        (e) => {
                          locationArray.push({
                            lat: e.Latitude,
                            lng: e.Longitude,
                          });
                        }
                      );
                      this.optionsXEN = {
                        center: {
                          lat: locationArray[0].lat,
                          lng: locationArray[0].lng,
                        },
                        zoom: 17,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                      };
                      let pointLocations = [];
                      locationArray.forEach((e) => {
                        pointLocations.push(
                          new google.maps.Marker({
                            position: { lat: e.lat, lng: e.lng },
                          })
                        );
                      });
                      this.overlaysXEN = [
                        ...pointLocations,
                        new google.maps.Polygon({
                          paths: [...locationArray],
                          strokeOpacity: 0.5,
                          strokeWeight: 1,
                          fillColor: '#1976D2',
                          fillOpacity: 0.35,
                        }),
                      ];

                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        optionsXEN: this.optionsXEN,
                        overlaysXEN: this.overlaysXEN,
                      };
                    } else {
                      this.showMapXEN = false;
                    }

                    if (this.physicalSurveyDetails?.listGPSCoordinatesSDO?.length > 0) {
                      this.showMapSDO = true;

                      let sdoOption = {
                        center: { lat: 29.0588, lng: 76.0856 },
                        zoom: 17,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                        draggable: true,
                      };

                      sdoOption.center = {
                        "lat": this.physicalSurveyDetails?.listGPSCoordinatesSDO[0][0]?.Latitude,
                        "lng": this.physicalSurveyDetails?.listGPSCoordinatesSDO[0][0]?.Longitude
                      };
                      let sdoOverlays = [];

                      // add marker
                      this.physicalSurveyDetails?.listGPSCoordinatesSDO.forEach((arr, tableIndex) => {
                        arr.forEach((row, index) => {
                          sdoOverlays.push(
                            new google.maps.Marker({
                              position: { lat: row?.Latitude, lng: row?.Longitude },
                              title: `${row?.CornerID}`,
                              draggable: false,
                              crossOnDrag: false
                            })
                          );
                        });
                      })

                      // add overlay
                      this.physicalSurveyDetails?.listGPSCoordinatesSDO.forEach(arr => {
                        let arr1 = arr.map(val => ({
                          lat: val?.Latitude,
                          lng: val?.Longitude
                        }))
                        sdoOverlays.push(
                          new google.maps.Polygon({
                            paths: arr1,
                            strokeOpacity: 0.5,
                            strokeWeight: 1,
                            fillColor: '#1976D2',
                            fillOpacity: 0.35,
                          })
                        );
                      })

                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        newGPSsdoArray: {
                          gpsArray: this.physicalSurveyDetails?.listGPSCoordinatesSDO,
                          overlaysSDO: sdoOverlays,
                          optionsSDO: sdoOption
                        }
                      }

                    } else {
                      this.showMapSDO = false;
                    }

                    if (this.calculatedSubsidyDataForMIPhys) {
                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        calculatedSubsidyDataForMIPhys:
                          this.calculatedSubsidyDataForMIPhys,
                      };
                      this.physicalSurveyDetailsArray.push(
                        this.physicalSurveyDetails
                      );
                    } else {
                      this.physicalSurveyDetailsArray.push(
                        this.physicalSurveyDetails
                      );
                    }
                  }
                },
                error: () => {
                  // this.loader.close();
                  // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Form Not Loaded' });
                },
              });
          },
        });
    }
  }

  getCalculatedSubsidyDataForMIPhys(autoId, userId) {
    this.jeService
      .getApplicationDataForPhysicalVerification(autoId, userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.calculatedSubsidyDataForMIPhys = data;
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
        },
      });
  }

  challanPaymentDetails(appId) {
    // this.loader.start();
    let sub = this.deptDashBoardService
      .getChallanPaymentDetails(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          if (data && data.length > 0) {
            this.showFarmerShareDepositeDetails = true;
            this.farmerShareDepositeDetails = data[0][0];
          } else {
            this.showFarmerShareDepositeDetails = false;
            this.farmerShareDepositeDetails = [];
            // this.messageService.add({
            //   severity: 'error',
            //   summary: 'Error Message',
            //   detail: 'Data Not Found',
            // });
          }
        },
        error: (err) => {
          this.showFarmerShareDepositeDetails = false;
          this.farmerShareDepositeDetails = [];
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }
  maskNumber(number: any) {
    let id = number.toString();
    if (id) {
      return id.slice(0, -4).replace(/./g, 'X') + id.slice(-4); //regex used here
    }
    return null

  }

  onClickApp(memAppId) {
    let statusCodeEncrypted = this.cryptoJsService.Encrypt(this.statusCode);
    const link = this.router.serializeUrl(
      this.router.createUrlTree([
        this.router.url.split('/')[1],
        'print',
      ], { queryParams: { appId: this.cryptoJsService.Encrypt(memAppId.toString()) } }));
    window.open(link, '_blank');
  }
}
